import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';
import { Brand } from 'app/brand-config';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

export function msalInstanceFactory(type: Brand) {
  const configs = environment.msal as any;
  const config = configs[type] || configs['Scania'];
  if (!config) {
    throw new Error(`MSAL configuration not found for brand: ${String(type)}`);
  }
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      redirectUri: environment.redirectUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  });
}

@Injectable({
  providedIn: 'root'
})
export class DynamicMsalService {
  constructor(private msalService: MsalService) { }

  async login(scopes: string[] = [`User.Read`]) {
    try {
      await this.msalService.instance.initialize();
      const loginResponse = await firstValueFrom(this.msalService.loginPopup({ scopes }));
      return loginResponse;
    } catch (error) {
      console.log('Login failed', error);
      throw error;
    }
  }

  async logout() {

    try {
      await this.msalService.logoutPopup();
    } catch (error) {
      console.log('Logout failed', error);
      throw error;
    }
  }
}

